import { render, staticRenderFns } from "./AskBubbleComponent.vue?vue&type=template&id=4e229e71"
import script from "./AskBubbleComponent.vue?vue&type=script&lang=ts"
export * from "./AskBubbleComponent.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports